import type { AcquirerEntity } from "src/app/features/Acquirer/types/AcquirerEntity";
import { AcquirerButton } from "src/app/features/ManualDasConfiguration/components/buttons/DasConfigAcquirerButtons";
import { HtmlCampaignStatusColorBadgeComponent } from "../../../../StatusBadge/HtmlCampaignStatusColorBadgeComponent";
import { HtmlOrgUnitStatusColorBadgeComponent } from "../../../../StatusBadge/HtmlOrgUnitStatusColorBadgeComponent";
import { HtmlStatusColorBadgeComponent } from "../../../../StatusBadge/HtmlStatusColorBadgeComponent";
import type { CellValue } from "../../../types/types";
import { CellDateTimeValue } from "./CellDateTimeValue";
import { CellDateValue } from "./CellDateValue";
import { CellEnumValue } from "./CellEnumValue";

export const displayStatusValue = (cellValue: CellValue) => {
    return <HtmlStatusColorBadgeComponent cellValue={cellValue} />;
};

export const displayDateTimeValue = (cellValue: CellValue) => {
    return <CellDateTimeValue cellValue={cellValue} />;
};

export const displayDateValue = (cellValue: CellValue) => {
    return <CellDateValue cellValue={cellValue} />;
};

export const displayEnumValue = (cellValue: CellValue, dataSource: string) => {
    return <CellEnumValue cellValue={cellValue} datasource={dataSource} />;
};

export const displayCampaignUpdateStatusValue = (cellValue: CellValue) => {
    return <HtmlCampaignStatusColorBadgeComponent cellValue={cellValue} />;
};

export const displayOrgUnitUpdateStatusValue = (cellValue: CellValue) => {
    return <HtmlOrgUnitStatusColorBadgeComponent cellValue={cellValue} />;
};

export const displayAcquirerButtons = (cellValue: AcquirerEntity[], type: string) => {
    return <AcquirerButton acquirers={cellValue} type={type} />;
};
